<template>
  <div :style="`height: ${contentHeight};`" class="overflow--y pa-4">
    <div v-if="hasRole('profiles', 'ROLE_ADMINISTRATOR')">
      <span class="company-group__title">
        {{ companyGroupName }}
      </span>

      <div>
        <div class="item__label text--capitalize">{{ $t('Common.companies') }}</div>
        <div v-if="isValidArray(data.companies)" class="mb-2">
          <div
            v-for="company in data.companies"
            :key="company.id"
            class="company-group__item"
          >
            <router-link
              :to="{
                name: 'CompanyDetail',
                params: { id: company.id }
              }"
              class="company-group__item__name"
            >
              {{ company.name }}
            </router-link>

            <span class="company-group__item__info">
              ID: {{ company.id }} / CNPJ: {{ company.documentId | cnpj }}
            </span>
          </div>
        </div>

        <div v-else>
          {{ $t(`${namespace}.emptyState`) }}
        </div>
      </div>
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import { calcContentHeight, isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Preview',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    EmptyState
  },
  computed: {
    companyGroupName () {
      return this.data && this.data.companyGroup && this.data.companyGroup.name
        ? this.data.companyGroup.name
        : '-'
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.companyGroup.preview',
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight()}px`
    },

    close () {
      this.$emit('close')
    },

    isValidArray (val) {
      return isValidArray(val)
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.company-group__title {
  border-bottom: 1px solid $gray-4;
  display: block;
  font-family: $title-font;
  font-weight: 800;
  margin-bottom: 24px;
  padding-bottom: 24px;
  text-align: center;
}

.company-group__item {
  margin: 8px 0 10px;
}

.company-group__item__name,
.company-group__item__info {
  display: block;
}

.company-group__item__name {
  color: $accent;
  text-decoration: none;
}

.company-group__item__info {}
</style>
